import { useState, useEffect } from 'react';
import { organizationApi } from '../services/api/organizationApi';

const useDeliveryPositions = () => {
  const [positions, setPositions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedPositions, setSelectedPositions] = useState([]);

  useEffect(() => {
    const fetchPositions = async () => {
      setLoading(true);
      try {
        const response = await organizationApi.getDeliveryPositions();
        setPositions(response);
        setError(null);
      } catch (err) {
        setError('Failed to load delivery positions');
        console.error('Error fetching delivery positions');
      } finally {
        setLoading(false);
      }
    };

    fetchPositions();
  }, []);

  return {
    positions,
    loading,
    error,
    selectedPositions,
    setSelectedPositions
  };
};

export default useDeliveryPositions; 